import { createSlice } from '@reduxjs/toolkit'
import { getFlipCoinBets, placeBetFlipCoin } from './flipCoinGame.thunk'

const initialState = {
  betHistoryData: [],
  placedBet: [],
  myBetsData: [],
  myBetsLoading: false,
  betLock: false,
  liveBets: {
    count: 0,
    rows: []
  },
  wins: 0,
  losses: 0,
  profit: 0,
  wagered: 0,
  lastBetCoinCount: 1
}

const {
  actions: {
    setPlacedBetsData,
    setLiveBets,
    setFlipCoinGameWins,
    setFlipCoinGameLosses,
    setFlipCoinGameProfit,
    setFlipCoinGameWagered,
    resetLiveStats,
    setLastBetCoinCount
  },
  reducer
} = createSlice({
  name: 'flipCoinGame',
  initialState,
  reducers: {
    setLiveBets: (state, action) => {
      return {
        ...state,
        liveBets: {
          count: action.payload?.count ?? 0,
          rows: action.payload?.rows ?? []
        }
      }
    },
    setPlacedBetsData: (state, action) => {
      return {
        ...state,
        betHistoryData: action.payload
      }
    },
    setFlipCoinGameWins: (state, action) => {
      if (action.payload) {
        return {
          ...state,
          wins: action.payload.reset
        }
      }
      return {
        ...state,
        wins: state.wins + 1
      }

    },

    setFlipCoinGameLosses: (state, action) => {
      if (action.payload) {
        return {
          ...state,
          losses: action.payload.reset
        }
      }
      return {
        ...state,
        losses: state.losses + 1
      }
    },
    setFlipCoinGameProfit: (state, action) => {
      return {
        ...state,
        profit: (+state.profit + +(action.payload).toFixed(2))
      }
    },
    setFlipCoinGameWagered: (state, action) => {
      return {
        ...state,
        wagered: (+state.wagered + +(action.payload).toFixed(2))
      }
    },
    resetLiveStats: (state, action) => {
      return {
        ...state,
        wins: 0,
        losses: 0,
        profit: 0,
        wagered: 0
      }
    },
     setLastBetCoinCount: (state, action) => {
      state.lastBetCoinCount = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFlipCoinBets.pending, (state, action) => {
        return {
          ...state,
          myBetsLoading: true
        }
      })
      .addCase(getFlipCoinBets.fulfilled, (state, action) => {
        return {
          ...state,
          myBetsData: action.payload.rows,
          myBetsLoading: false
        }
      })
      .addCase(placeBetFlipCoin.pending, (state, action) => {
        return {
          ...state,
          placedBet: action.payload,
          betLock: true
        }
      })
      .addCase(placeBetFlipCoin.fulfilled, (state, action) => {
        return {
          ...state,
          placedBet: action.payload,
          betLock: false,
          myBetsData: [action.payload, ...state.myBetsData]
        }
      })
      .addCase(placeBetFlipCoin.rejected, (state, action) => {
        return {
          ...state,
          placedBet: action.payload,
          betLock: false
        }
      })
  }
})

export default reducer
export {
  setPlacedBetsData,
  setLiveBets,
  setFlipCoinGameWins,
  setFlipCoinGameLosses,
  setFlipCoinGameProfit,
  setFlipCoinGameWagered,
  resetLiveStats,
  setLastBetCoinCount
}
